import { Fragment, useEffect } from "react";
import { Link } from "react-router-dom";
import { useDispatch } from "react-redux";
import Card from "../Card";
import { updateUserStatus } from "../../../store/redux_auth/authSlice";

function TestResults(props) {
  const dispatch = useDispatch();

  useEffect(() => {
    if (props.result === true) {
      // Update Redux cpa_status to DN (Done with test)
      dispatch(updateUserStatus({ account_status: "DN" }));
    }
  }, [props.result, dispatch]);

  return (
    <Fragment>
      <Card result={props.result} message={props.message} />
      {!props.result && props.attempts === 0 && (
        <>
          <h1 style={{textAlign:"center"}}>You can try again in two weeks</h1>
        </>
      )}
      {!props.result && props.attempts !== 0 && (
        <>
          <Link
            className="cta-button primary"
            data-icon="arrow_forward"
            to="/onboard"
            style={{ margin: "0 auto" }}
          >
            <b>Re-take Test</b>
          </Link>
        </>
      )}
      {props.result && (
        <>
          <Link
            className="cta-button primary"
            data-icon="arrow_forward"
            to="/onboard"
            style={{ margin: "0 auto" }}
          >
            <b>Go to Next Step</b>
          </Link>
        </>
      )}
    </Fragment>
  );
}

export default TestResults;
